import { PropsWithChildren, useState } from 'react';
import { ScheduleMemo } from '#types/schedule';
import Icon from 'src/components/atoms/Icon';
import * as S from './styles';

interface CardMemoProps extends Partial<ScheduleMemo> {}

export default function CardMemo({ memo }: PropsWithChildren<CardMemoProps>) {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  return (
    <S.Wrapper>
      <S.Badge>메모</S.Badge>
      <S.Contents isExpanded={!!isExpanded}>{memo}</S.Contents>
      <S.ButtonExpand onClick={() => setIsExpanded(prev => !prev)}>
        <S.IconWrapper isExpanded={!!isExpanded}>
          <Icon name="IconArrowDown" />
        </S.IconWrapper>
      </S.ButtonExpand>
    </S.Wrapper>
  );
}
